module.exports = __webpack_public_path__ + "img/lottery.31a6b039.png";